import { render, staticRenderFns } from "./sw-qsg.vue?vue&type=template&id=7960c0c9&"
import script from "./sw-qsg.vue?vue&type=script&lang=tsx&"
export * from "./sw-qsg.vue?vue&type=script&lang=tsx&"
import style0 from "./sw-qsg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports